import axios, { AxiosRequestConfig } from 'axios';

// Create axios instance with baseUrl and header.
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});


// Add a request interceptor to add token in request header.
axiosInstance.interceptors.request.use((requestConfig: AxiosRequestConfig): AxiosRequestConfig => {
    // Get token from localStorage
    const token = localStorage.getItem('token');

    if (requestConfig.headers) {
        requestConfig.headers.Authorization = token ? `jwt ${token}` : '';
    }

    return requestConfig;
});
const responseHandler = (response: any) => {
    if (response.status === 401) {
        console.log('token expired!');

        (window as any).location = '/signin';
    }

    return response;
};

const errorHandler = (error: any) => {
    const errJSON = error.toJSON();
    console.log('error: ', error.toJSON());

    if (errJSON.status === 401) {

        window.localStorage.clear();
        window.sessionStorage.clear();

        (window as any).location = '/signin';
    }
    return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);

export default axiosInstance;
